// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderSection_root__vsx2w","breadcrumb":"HeaderSection_breadcrumb__cmxpy","headerImage":"HeaderSection_headerImage__miNuq"};